<div class="container-fluid complyon-page facilities-page px-3 px-md-4 px-xl-4 py-3">
  <div class="complyon-shell facilities-shell mx-auto">
    <section class="mb-3">
      <h1 class="complyon-title facilities-title mb-2 text-l">Facilities & sites</h1>
      <p class="complyon-subtitle facilities-subtitle mb-0 text-s">
        Compliance by physical location - certificates, maintenance, health & safety and open issues rolled up into a site compliance score.
      </p>
    </section>

    <section class="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-3">
      <div class="d-flex flex-wrap align-items-center gap-1">
        <button
          v-for="tab in tabs"
          :key="tab.id"
          type="button"
          class="btn doa-tab-btn fw-semibold"
          :class="{ active: active_tab === tab.id }"
          @click="set_tab(tab.id)"
        >
          <span>{{ tab.label }}</span>
          <span v-if="tab.count !== undefined" class="doa-tab-count">{{ tab.count }}</span>
        </button>
      </div>

      <button type="button" class="btn doa-reset-btn d-inline-flex align-items-center gap-1">
        <i class="bi bi-arrow-clockwise"></i>
        <span>Reset sample</span>
      </button>
    </section>

    <div v-if="active_tab === 'sites'">
      <section class="mb-3">
        <div class="rounded-4 border px-3 py-3" style="background:#e8f8f5;border-color:#bce9df;">
          <div class="d-flex align-items-start gap-2 text-s">
            <i class="bi bi-building mt-1 text-success"></i>
            <div>
              <strong>Compliance by location.</strong>
              Every site rolls its certificates, inspections, maintenance, utilities, security and incidents into one compliance score - so a failing branch is visible the moment a certificate lapses.
            </div>
          </div>
        </div>
      </section>

      <section class="row g-3 mb-3">
        <div v-for="card in site_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
          <article class="complyon-card rounded-4 p-3 h-100">
            <div class="complyon-stat-label text-xs">{{ card.label }}</div>
            <div class="complyon-stat-value text-l" :class="card.accent === 'red' ? 'text-danger' : card.accent === 'amber' ? 'text-warning-emphasis' : 'text-success'">{{ card.value }}</div>
            <div class="complyon-stat-note mt-3 text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel rounded-4 overflow-hidden">
        <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
          <div>
            <div class="complyon-section-title text-s">Site register</div>
            <div class="complyon-section-subtitle text-xs">Open a site for its certificates, inspections, maintenance, utilities, security, linked assets, incidents and evidence pack.</div>
          </div>
          <button type="button" class="btn config-navbar-primary-action finance-action-btn" @click="open_site_modal">
            <i class="bi bi-plus-lg"></i>
            <span>Add site</span>
          </button>
        </div>

        <div class="px-3 pb-2 pt-2">
          <div class="d-flex flex-wrap align-items-center gap-1 mb-2">
            <button
              v-for="filter in visible_sites_filters"
              :key="filter.id"
              type="button"
              class="btn doa-tab-btn fw-semibold"
              :class="{ active: filter.active }"
              @click="set_sites_filter(filter.id)"
            >
              <span>{{ filter.label }}</span>
            </button>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table complyon-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3">Ref</th>
                <th>Site</th>
                <th>Type</th>
                <th>Region</th>
                <th>Compliance</th>
                <th>Risk</th>
                <th>Open</th>
                <th>Status</th>
                <th class="pe-3"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in filtered_site_rows"
                :key="row.ref"
                class="facilities-row-clickable"
                role="button"
                tabindex="0"
                @click="open_site_drawer(row.ref)"
                @keydown.enter.prevent="open_site_drawer(row.ref)"
                @keydown.space.prevent="open_site_drawer(row.ref)"
              >
                <td class="ps-3"><div class="procurement-id">{{ row.ref }}</div></td>
                <td><div class="procurement-name">{{ row.site }}</div></td>
                <td>{{ row.type }}</td>
                <td>{{ row.region }}</td>
                <td>
                  <div class="d-flex align-items-center gap-2">
                    <div class="flex-grow-1 rounded-1 overflow-hidden" style="height:6px;background:#e6ebf1;">
                      <div class="h-100 rounded-1" :style="{ width: `${row.compliance}%`, background: row.risk.label === 'Critical' ? '#c1261a' : row.risk.label === 'Medium' ? '#c75a06' : '#11827a' }"></div>
                    </div>
                    <div class="fw-semibold text-xs">{{ row.compliance }}%</div>
                  </div>
                </td>
                <td><span class="badge complyon-badge text-xs" :class="row.risk.class">{{ row.risk.label }}</span></td>
                <td class="fw-semibold">{{ row.open }}</td>
                <td><span class="badge complyon-badge text-xs" :class="row.status.class">{{ row.status.label }}</span></td>
                <td class="pe-3 text-end"><i class="bi bi-chevron-right finance-arrow"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'certificates'">
      <section class="row g-3 mb-3">
        <div v-for="card in certificate_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
          <article class="complyon-card rounded-4 p-3 h-100">
            <div class="complyon-stat-label text-xs">{{ card.label }}</div>
            <div class="complyon-stat-value text-l" :class="card.accent === 'red' ? 'text-danger' : card.accent === 'amber' ? 'text-warning-emphasis' : 'text-success'">{{ card.value }}</div>
            <div class="complyon-stat-note mt-3 text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel rounded-4 overflow-hidden">
        <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
          <div>
            <div class="complyon-section-title text-s">Certificates & inspections</div>
            <div class="complyon-section-subtitle text-xs">Every fire certificate, licence and safety inspection across the estate, expired and overdue first. Open the site to renew or book.</div>
          </div>
        </div>

        <div class="table-responsive">
          <table class="table complyon-table align-middle mb-0">
            <thead>
              <tr>
                <th class="ps-3">Type</th>
                <th>Item</th>
                <th>Site</th>
                <th>When</th>
                <th>Status</th>
                <th class="pe-3"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in certificate_rows"
                :key="`${row.type}-${row.item}`"
                class="facilities-row-clickable"
                :class="{ 'bg-light': row.highlighted }"
                role="button"
                tabindex="0"
                @click="open_site_drawer(row.site_ref)"
                @keydown.enter.prevent="open_site_drawer(row.site_ref)"
                @keydown.space.prevent="open_site_drawer(row.site_ref)"
              >
                <td class="ps-3">{{ row.type }}</td>
                <td><div class="procurement-name">{{ row.item }}</div></td>
                <td>{{ row.site }}</td>
                <td :class="row.when.includes('Overdue') || row.when.includes('Expiry 02 Apr 2026') ? 'text-danger fw-semibold' : 'fw-semibold'">{{ row.when }}</td>
                <td><span class="badge complyon-badge text-xs" :class="row.status.class">{{ row.status.label }}</span></td>
                <td class="pe-3 text-end"><i class="bi bi-chevron-right finance-arrow"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </div>

    <div v-else-if="active_tab === 'incidents'">
      <section class="row g-3 mb-3">
        <div v-for="card in incident_cards" :key="card.label" class="col-12 col-md-6 col-xl-3">
          <article class="complyon-card rounded-4 p-3 h-100">
            <div class="complyon-stat-label text-xs">{{ card.label }}</div>
            <div class="complyon-stat-value text-l" :class="card.accent === 'red' ? 'text-danger' : card.accent === 'amber' ? 'text-warning-emphasis' : 'text-success'">{{ card.value }}</div>
            <div class="complyon-stat-note mt-3 text-xs">{{ card.note }}</div>
          </article>
        </div>
      </section>

      <section class="complyon-panel rounded-4 overflow-hidden">
        <div class="d-flex align-items-start justify-content-between gap-2 px-3 pt-3">
          <div>
            <div class="complyon-section-title text-s">Site incidents</div>
            <div class="complyon-section-subtitle text-xs">Safety and security incidents by location, linked to the HSE corrective actions and insurance claims they drive.</div>
          </div>
        </div>

        <div class="px-3 pb-2">
          <div
            v-for="row in incident_rows"
            :key="row.title"
            class="d-flex align-items-center justify-content-between gap-3 py-3 border-bottom facilities-row-clickable"
            role="button"
            tabindex="0"
            @click="open_site_drawer(row.site_ref)"
            @keydown.enter.prevent="open_site_drawer(row.site_ref)"
            @keydown.space.prevent="open_site_drawer(row.site_ref)"
          >
            <div class="d-flex align-items-start gap-3 min-w-0">
              <div class="rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0" style="width:32px;height:32px;background:#e8f8f5;color:#13856f;">
                <i class="bi bi-shield-exclamation"></i>
              </div>
              <div class="min-w-0">
                <div class="procurement-name">{{ row.title }}</div>
                <div class="procurement-request-meta">{{ row.subtitle }}</div>
              </div>
            </div>
            <div class="d-flex align-items-center gap-3 flex-shrink-0">
              <span class="badge complyon-badge text-xs" :class="row.status.class">{{ row.status.label }}</span>
              <i class="bi bi-chevron-right finance-arrow"></i>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

  <div v-if="site_modal_open" class="finance-modal-backdrop" @click.self="close_site_modal">
    <div class="finance-modal-shell employees-modal" role="dialog" aria-modal="true" aria-label="Add site">
      <div class="finance-modal-header employees-modal-header">
        <div>
          <h3 class="employees-modal-title">Add site</h3>
          <p class="employees-modal-subtitle">Register a site for certificate, maintenance, utilities and safety monitoring.</p>
        </div>
        <button type="button" class="employees-modal-close" @click="close_site_modal">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <div class="finance-modal-body employees-modal-body">
        <div class="row g-3">
          <div class="col-12">
            <label class="employees-modal-label">Site</label>
            <input v-model="site_form.site" type="text" class="employees-modal-input" placeholder="e.g. East London office">
          </div>
          <div class="col-12 col-md-6">
            <label class="employees-modal-label">Type</label>
            <select v-model="site_form.type" class="employees-modal-input">
              <option v-for="type in site_types" :key="type" :value="type">{{ type }}</option>
            </select>
          </div>
          <div class="col-12 col-md-6">
            <label class="employees-modal-label">Status</label>
            <select v-model="site_form.status" class="employees-modal-input">
              <option v-for="status in site_statuses" :key="status" :value="status">{{ status }}</option>
            </select>
          </div>
          <div class="col-12 col-md-6">
            <label class="employees-modal-label">Region</label>
            <input v-model="site_form.region" type="text" class="employees-modal-input" placeholder="e.g. Eastern Cape">
          </div>
          <div class="col-12 col-md-6">
            <label class="employees-modal-label">Responsible manager</label>
            <input v-model="site_form.manager" type="text" class="employees-modal-input" placeholder="Name - role">
          </div>
          <div class="col-12">
            <label class="employees-modal-label">Address</label>
            <input v-model="site_form.address" type="text" class="employees-modal-input" placeholder="Street / area">
          </div>
          <div class="col-12">
            <label class="employees-modal-label">Note</label>
            <textarea v-model="site_form.note" class="employees-modal-input" rows="3" placeholder="Compliance context"></textarea>
          </div>
        </div>
      </div>

      <div class="finance-modal-footer employees-modal-footer">
        <button type="button" class="employees-modal-secondary" @click="close_site_modal">Cancel</button>
        <button type="button" class="btn config-navbar-primary-action" @click="create_site">
          <i class="bi bi-plus-lg"></i>
          <span>Create</span>
        </button>
      </div>
    </div>
  </div>

  <div v-if="active_site_drawer" class="command-centre-drawer-backdrop" @click="close_site_drawer">
    <aside class="command-centre-drawer facilities-drawer" role="dialog" aria-modal="true" :aria-label="active_site_drawer.title" @click.stop>
      <header class="command-centre-drawer-header border-bottom">
        <div class="d-flex align-items-start justify-content-between gap-3">
          <div class="min-w-0">
            <div class="command-centre-drawer-kicker">{{ active_site_drawer.section }}</div>
            <div class="command-centre-drawer-title mt-1">{{ active_site_drawer.title }}</div>
            <div class="command-centre-drawer-subtitle mt-1">{{ active_site_drawer.subtitle }}</div>
          </div>
          <div class="d-flex align-items-center gap-2 flex-shrink-0">
            <span class="badge complyon-badge text-xs" :class="active_site_drawer.status_class">{{ active_site_drawer.status }}</span>
            <button type="button" class="btn btn-link p-0 assets-modal-close" @click="close_site_drawer" aria-label="Close drawer">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
        </div>
      </header>

      <div class="command-centre-drawer-body facilities-drawer-body">
        <section class="facilities-drawer-topgrid mb-3">
          <article class="employees-drawer-score-card">
            <div class="employees-drawer-section-kicker">Compliance score</div>
            <div class="employees-drawer-score-row">
              <div class="employees-drawer-score" :class="`is-${active_site_drawer.score_tone}`">{{ active_site_drawer.score }}%</div>
              <div class="employees-drawer-score-bar">
                <span :class="`is-${active_site_drawer.score_tone}`" :style="{ width: `${active_site_drawer.score}%` }"></span>
              </div>
            </div>
          </article>
          <article class="employees-drawer-score-card">
            <div class="employees-drawer-section-kicker">Risk</div>
            <div class="command-centre-drawer-meta-value mt-1">{{ active_site_drawer.risk }}</div>
          </article>
          <article class="employees-drawer-score-card">
            <div class="employees-drawer-section-kicker">Open items</div>
            <div class="command-centre-drawer-meta-value mt-1">{{ active_site_drawer.open_items }}</div>
          </article>
          <article class="employees-drawer-score-card">
            <div class="employees-drawer-section-kicker">Occupancy</div>
            <div class="command-centre-drawer-meta-value mt-1">{{ active_site_drawer.occupancy }}</div>
          </article>
        </section>

        <section class="employees-drawer-section mb-3">
          <div class="employees-drawer-section-title">Site profile</div>
          <div class="row g-2">
            <div v-for="meta in active_site_drawer.metadata" :key="meta.label" class="col-6">
              <div class="command-centre-drawer-meta-label">{{ meta.label }}</div>
              <div class="command-centre-drawer-meta-value mt-1">{{ meta.value }}</div>
            </div>
          </div>
        </section>

        <section class="employees-drawer-section mb-3">
          <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
            <div class="employees-drawer-section-title">Certificates</div>
            <span class="text-xs text-secondary">+ Add</span>
          </div>
          <div class="employees-drawer-list">
            <div v-for="item in active_site_drawer.certificates" :key="item.title" class="employees-drawer-item">
              <div class="employees-drawer-item-main">
                <div class="employees-drawer-item-title">{{ item.title }}</div>
                <div class="employees-drawer-item-subtitle">{{ item.subtitle }}</div>
              </div>
              <span class="employees-drawer-item-state" :class="`is-${item.tone}`">{{ item.state }}</span>
            </div>
          </div>
        </section>

        <section class="employees-drawer-section mb-3">
          <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
            <div class="employees-drawer-section-title">Maintenance schedule</div>
            <span class="text-xs text-secondary">+ Add</span>
          </div>
          <div class="employees-drawer-list">
            <div v-for="item in active_site_drawer.maintenance" :key="item.title" class="employees-drawer-item">
              <div class="employees-drawer-item-main">
                <div class="employees-drawer-item-title">{{ item.title }}</div>
                <div class="employees-drawer-item-subtitle">{{ item.subtitle }}</div>
              </div>
              <span class="employees-drawer-item-state" :class="`is-${item.tone}`">{{ item.state }}</span>
            </div>
          </div>
        </section>

        <section class="employees-drawer-section mb-3">
          <div class="employees-drawer-section-title mb-2">Utilities</div>
          <div class="employees-drawer-list">
            <div v-for="item in active_site_drawer.utilities" :key="item.title" class="employees-drawer-item">
              <div class="employees-drawer-item-main">
                <div class="employees-drawer-item-title">{{ item.title }}</div>
                <div class="employees-drawer-item-subtitle">{{ item.subtitle }}</div>
              </div>
              <span class="employees-drawer-item-state" :class="`is-${item.tone}`">{{ item.state }}</span>
            </div>
          </div>
        </section>

        <section class="employees-drawer-section mb-3">
          <div class="employees-drawer-section-title mb-2">Security</div>
          <div class="employees-drawer-list">
            <div v-for="item in active_site_drawer.security" :key="item.title" class="employees-drawer-item">
              <div class="employees-drawer-item-main">
                <div class="employees-drawer-item-title">{{ item.title }}</div>
                <div class="employees-drawer-item-subtitle">{{ item.subtitle }}</div>
              </div>
              <span class="employees-drawer-item-state" :class="`is-${item.tone}`">{{ item.state }}</span>
            </div>
          </div>
        </section>

        <section v-if="active_site_drawer.incidents.length" class="employees-drawer-section mb-3">
          <div class="employees-drawer-section-title mb-2">Site incidents</div>
          <div class="employees-drawer-list">
            <div v-for="item in active_site_drawer.incidents" :key="item.title" class="employees-drawer-item">
              <div class="employees-drawer-item-main">
                <div class="employees-drawer-item-title">{{ item.title }}</div>
                <div class="employees-drawer-item-subtitle">{{ item.subtitle }}</div>
              </div>
              <span class="employees-drawer-item-state" :class="`is-${item.tone}`">{{ item.state }}</span>
            </div>
          </div>
        </section>

        <section class="employees-drawer-section mb-3">
          <div class="employees-drawer-section-title mb-2">Connected records</div>
          <div class="employees-drawer-records">
            <div v-for="record in active_site_drawer.linked" :key="`${record.type}-${record.title}`" class="employees-drawer-record">
              <div class="command-centre-drawer-kicker">{{ record.type }}</div>
              <div class="employees-drawer-record-title">{{ record.title }}</div>
              <div class="employees-drawer-record-link"><i class="bi bi-box-arrow-up-right"></i></div>
            </div>
          </div>
        </section>

        <section class="employees-drawer-section mb-3">
          <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
            <div class="employees-drawer-section-title">Site evidence pack</div>
            <span class="text-xs text-warning-emphasis">{{ active_site_drawer.team_notes.length }} of 5</span>
          </div>
          <div class="employees-drawer-list">
            <div v-for="item in active_site_drawer.team_notes" :key="item.title" class="employees-drawer-item">
              <div class="employees-drawer-item-main">
                <div class="employees-drawer-item-title">{{ item.title }}</div>
                <div class="employees-drawer-item-subtitle">{{ item.subtitle }}</div>
              </div>
              <span class="employees-drawer-item-state" :class="`is-${item.tone}`">{{ item.state }}</span>
            </div>
          </div>
        </section>

        <section class="employees-drawer-recommendation">
          <div class="employees-drawer-section-kicker">Recommended action</div>
          <div class="assets-drawer-recommendation-copy">{{ active_site_drawer.recommended_action }}</div>
        </section>
      </div>

      <footer class="employees-drawer-footer">
        <button type="button" class="employees-drawer-footer-link">Evidence pack</button>
        <button type="button" class="btn config-navbar-primary-action">Edit site</button>
      </footer>
    </aside>
  </div>
</div>
